/**
 * The flag keys that exist as rows in `app_settings`.
 *
 * ⚠️ SEPARATE MODULE ON PURPOSE — do not move these into `useAppSetting.ts`.
 *
 * Component tests mock that hook wholesale
 * (`vi.mock("@/hooks/useAppSetting", () => ({ useAppSetting: () => true }))`),
 * which replaces every export the module has. Constants living there would
 * become `undefined` inside those tests and every call site would throw on
 * `APP_SETTING_KEYS.SMS_LIVE` — which is exactly what happened on the first
 * attempt at #410, breaking 52 tests in `howKinReachesYou.test.tsx` and
 * `morningNotesSmsChip.test.tsx`.
 *
 * A constants module has no side effects and never needs mocking, so those
 * test files keep working untouched. #410's task 6 asked for precisely that.
 *
 * ⚠️ The string VALUES must match the live database rows EXACTLY, including
 * casing. The live rows genuinely use two conventions — `SMS_LIVE` shouting,
 * `pro_launch_live` and `beauty_analyzer_enabled` quiet — and that
 * inconsistency is why a typo was easy to make in the first place. Do not
 * normalise them: renaming a constant is free, renaming a key silently turns
 * the feature off for everyone and passes every test.
 */
export const APP_SETTING_KEYS = {
  SMS_LIVE: "SMS_LIVE",
  PRO_LAUNCH_LIVE: "pro_launch_live",
  BEAUTY_ANALYZER_ENABLED: "beauty_analyzer_enabled",
} as const;

export type AppSettingKey = (typeof APP_SETTING_KEYS)[keyof typeof APP_SETTING_KEYS];

/** Runtime membership check for callers that arrive from untyped code. */
export const KNOWN_APP_SETTING_KEYS: readonly string[] = Object.values(APP_SETTING_KEYS);
